<template>
  <div>
    <div style="padding: 15px 50px 15px 30px" class="blue_holder mb-4">
      <h4 class="mb-4">Attendance Status</h4>
      <p>{{attendance_type}}</p>
    </div>

    <div style="padding: 15px 30px" class="blue_holder">
      <h4 class="mb-4">Schedule</h4>
      <div class="flex flex-wrap justify-between items-center">
        <p>
          {{
            eachEventInfo.extendedProps.course.schedule_from_time.slice(0, -3)
          }}-{{
            eachEventInfo.extendedProps.course.schedule_to_time.slice(0, -3)
          }}
        </p>
        <div class="inline-flex">
          <vs-button
            class="mr-2"
            type="border"
            color="danger"
            disabled="true"
            >Can't make it</vs-button
          >
          <vs-button @click="checkRescheduleStatus" :disabled="checkReshedule">Reschedule</vs-button>
        </div>
      </div>
    </div>
    <div>
      <div style="background: #effeff">
        
       <div v-if="resheduleCalender">
        <Reschedule :eachEventInfo="eachEventInfo" :resheduleCalender="resheduleCalender" :schedule_start_date="schedule_start_date" @closeCalendarAttendance="closeCalendarAttendance" />
       </div>

        <div class="time_zone_holder p-4">
          <h6 class="mb-4">Your Previous reschedule</h6>
          <ol style="list-style-type: auto; margin-left: 15px">
            <template v-for="(reshedule, index) in reschedulesList">
              <li :key="index">
                Changed from {{ reshedule.schedule_from_time.slice(0, -3) }} -
                {{ reshedule.schedule_to_time.slice(0, -3) }} of
                {{ reshedule.schedule_from_date }} to
                {{ reshedule.changed_from_time.slice(0, -3) }} -
                {{ reshedule.schedule_to_time.slice(0, -3) }} of
                {{ reshedule.changed_from_date }}
              </li>
            </template>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import {  cancelSchedulerApi, getStudentListForSchedule } from '@/api/schedulerApi'

import Reschedule from '@/views/pages/schedule/resheduleComponent.vue'
import {fetchResheduleLog, checkOwnStatus} from '@/api/calenderActions.js'
export default {
  components: {
    Reschedule
  },
  mounted () {
    this.checkOwnStatus()
    this.fetchResheduleLog()
  },
  props: {
    eachEventInfo: {
      default: {}
    }
  },
  computed: {
    checkReshedule () {
      if (this.schoolAdmin) {
        return false
      } else if (this.$moment().diff(this.eachEventInfo.start, 'minutes') <= 0) return false
      else return true
    }
  },
  data () {
    return {
      remainingReschedule: null,
      clientListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      clientList: [],
      TeacherListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      TeacherList: [],
      reschedulesList: [],
      showDropdown: false,
      list_dropdown: false,
      resheduleCalender: false,
      attendance: false,
      delay_in_minutes: 0,
      attendance_type:'',
      active_el: null,
      timeSlot: null,
      available_time: '',
      schedule_start_date: null,
      attendance_radio: null,
      customer_id: localStorage.getItem('customer_id')
    }
  },
  methods: {
    async checkOwnStatus () {
      console.log(this.eachEventInfo.extendedProps)
      const payload = {
        course_id:this.eachEventInfo.extendedProps.course.course_id,
        schedule_id: this.eachEventInfo.extendedProps.course.id,
        attendance_date: this.eachEventInfo.extendedProps.course.schedule_date
      }
      const { data } = await checkOwnStatus(this.customer_id, payload)
      this.attendance_type = data.data.attendance === null ? 'Unrecorded' : data.data.attendance ? 'Present' : 'Absent'
      this.delay_in_minutes = data.data.delay_in_minutes
    },
    closeCalendarAttendance () {
      this.fetchResheduleLog()
      this.$emit('closeCalendarAttendance', true)
    },
    checkRescheduleStatus () {
      if (this.remainingReschedule === 0) {
        this.showSuccessMessage(
          'Error',
          'You have reached the maximum number of reschedules for this course',
          'danger'
        )
      } else {
        this.resheduleCalender = true
      }
    },
    async fetchResheduleLog () {
      console.log(this.eachEventInfo.extendedProps.course)
      const payload = {
        group_id:this.eachEventInfo.extendedProps.course.group_id,
        course_id:this.eachEventInfo.extendedProps.course.course_id
      }
      const { data } = await fetchResheduleLog(this.customer_id, payload)
      this.reschedulesList = data.data.reschedules
      //this.remainingReschedule = data.data.remaining_count
      this.remainingReschedule = 5
    }
  }
}
</script>